// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyB9U32k9ym0K6BqnkX0SVZuIEVb40X71Lc",
  authDomain: "clone-505e6.firebaseapp.com",
  projectId: "clone-505e6",
  storageBucket: "clone-505e6.appspot.com",
  messagingSenderId: "458865567385",
  appId: "1:458865567385:web:7ea9d4e46b28d700917a08",
  measurementId: "G-TMMZMQCL9X",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export default firebaseConfig;
